import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { getLiteral } from 'utils/getLiteral';
import './styles.scss';

class NoResultsTable extends PureComponent {
    state = {};

    render() {
        const { icon, subtitle } = this.props;
        return (
            <div className="fm-no-results-table">
                <div className="fm-no-results-table__content">
                    <div className="fm-no-results-table__icon">{icon}</div>
                    <div className="fm-no-results-table__title">
                        {getLiteral('error_notresultfound')}
                    </div>
                    {subtitle && (
                        <div className="fm-no-results-table__subtitle">{getLiteral(subtitle)}</div>
                    )}
                </div>
            </div>
        );
    }
}

export default NoResultsTable;
